var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-pic-time-hero background mobile:pt-8 tablet:pt-20"},[_c('VimeoEmbed',{staticClass:"mx-auto container max-w-5xl tabletLandscape:mb-40",attrs:{"video-url":_vm.sectionHero.videoSources.videoUrl,"video-poster-url":_vm.sectionHero.videoSources.videoPosterUrl,"video-id":"hero-background-video"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }